import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ModalPage } from './modal.page';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
// import { PdfViewerModule } from 'ng2-pdf-viewer'; 
//import { SimplePdfViewerModule } from 'simple-pdf-viewer';
// import { BnNgPdfViewerModule } from 'bn-ng-pdf-viewer';
import { BrowserModule } from '@angular/platform-browser';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { AvatarComponent } from './components/avatar/avatar.component';

const routes: Routes = [
  {
    path: '',
    component: ModalPage
  }
];

@NgModule({
  imports: [BrowserModule,
     // PdfViewerModule ,
     //SimplePdfViewerModule,
     //BnNgPdfViewerModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,

  ],
  declarations: [ModalPage, NotificationsComponent,AvatarComponent]
})
export class ModalPageModule {}
